import React from "react"

// eslint-disable-next-line import/no-anonymous-default-export
const Icons = {
  add: <path d="M20 11.5v1h-7.5V20h-1v-7.5H4v-1h7.5V4h1v7.5H20z" />,
  edit: (
    <path d="M21 5.944c0 .387-.073.762-.22 1.125-.146.364-.36.686-.641.967L8.563 19.611 3 21l1.389-5.563L15.964 3.86c.281-.28.603-.495.967-.641.363-.147.738-.22 1.125-.22.404 0 .785.078 1.142.233a3 3 0 01.936.633c.267.266.478.578.633.936.155.357.233.738.233 1.142zM5.865 15.551a4.012 4.012 0 012.584 2.584l9.501-9.51-2.575-2.575-9.51 9.5zm-1.318 3.902l2.891-.72a2.83 2.83 0 00-2.17-2.172l-.721 2.892zM18.75 7.825c.146-.146.287-.284.422-.413s.255-.265.36-.409a1.686 1.686 0 00.343-1.05c0-.252-.048-.488-.145-.707a1.888 1.888 0 00-.976-.976 1.737 1.737 0 00-.707-.145c-.223 0-.418.03-.585.092a1.882 1.882 0 00-.465.25c-.144.106-.28.226-.41.361-.128.135-.266.275-.412.422l2.575 2.575z" />
  ),
  hamburger: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 3h24v2H0V3zM0 11h24v2H0v-2zM0 19h24v2H0v-2z"
    />
  ),
  close: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.914 10.5l7.5-7.5 1.414 1.414-7.5 7.5L20.414 19 19 20.414l-7.086-7.086-7.086 7.086L3.414 19l7.086-7.086-7.5-7.5L4.414 3l7.5 7.5z"
      />
    </>
  ),
  file: (
    <>
      <path d="M5.888 2.223c-.672 0-1.21.55-1.21 1.222l-.012 17.111c0 .672.538 1.222 1.222 1.222H18.11c.673 0 1.223-.55 1.223-1.222V8.334l-6.111-6.111H5.888zm7.334 6.11V3.446l4.888 4.889h-4.888z" />
    </>
  ),
}

export default Icons